// Page Functions

var canBeLoaded = true,
    headerHeight;

window.PageFunctions = {
	
	setup: function() {
        this.eventListeners();
        this.mobileMenuSubMenus();
        this.checkScrollPosition();
	},     

    eventListeners: function() {

        // // Menu Trigger
        document.querySelector('.menu-trigger-container').addEventListener('click', function(e) {
            e.preventDefault();
            document.body.classList.toggle('menu-open');
        });

        // Prevent Default on Main Menu Links
        let main_menu_links = document.querySelectorAll('.desktop-menu a[href="#"]');
        main_menu_links.forEach((el, index) => {
            el.addEventListener( 'click', function(e) {
                e.preventDefault();
            });
        });

        // Scroll To Anchor Links
        let anchor_links = document.querySelectorAll('main.main a[href^="#"]:not(.noscroll):not([data-lity])');
        anchor_links.forEach((el, index) => {
            el.addEventListener( 'click', window.PageFunctions.scrollToTopOfDivWithOffset );
        });

        // Shrink Header On Scroll
        window.addEventListener( 'scroll', window.PageFunctions.shrinkHeaderOnScroll );

    },

    mobileMenuSubMenus: function() {

        // Open Mobile Sub Meus
        let mobile_sub_links = document.querySelectorAll('.mobile-menu .has-children > a');

        mobile_sub_links.forEach((el, index) => {
            
            var sub_menu = window.helpers.next(el);
            let parent   = window.helpers.parent(el);
           
            el.addEventListener( 'click', function(e) {
                e.preventDefault();
                window.helpers.slideToggle(sub_menu, 500);
                window.helpers.toggleClass(el, 'menu-item-open');
            } );

            
        })
    },



    openMobileMegaNavs: function(e) {
        e.preventDefault();

        let next   = window.helpers.next(e.target);
        let parent = window.helpers.parent(e.target);

        window.helpers.slideToggle(next, 500);
        window.helpers.toggleClass(parent, 'mega-nav-item-open');

    },

    /**
     * Scroll to the top of a div with header offset
     */
    scrollToTopOfDivWithOffset: function(e) {

        e.preventDefault();

        let href   = e.target.getAttribute('href');

        if (href != '#') {
            let target = href.replace("#", "");
            
            let element         = document.getElementById( target );
            let headerOffset    = 120;
            let elementPosition = element.getBoundingClientRect().top;
            let offsetPosition  = elementPosition + window.pageYOffset - headerOffset;
              
            window.scrollTo({
                 top: offsetPosition,
                 behavior: "smooth"
            });
        }

    },

    /**
     *  Add shrink class to header on scroll
     */
    shrinkHeaderOnScroll: function() {

        let scroll_position = window.helpers.scrollTop(window);
        let threshold       = 50;
        let body            = document.body;

        if ( scroll_position > threshold ) {
            window.helpers.addClass(body, 'shrink');
        } else {
            window.helpers.removeClass(body, 'shrink');
        }

    },
    checkScrollPosition: function() {

        let scroll_position = window.helpers.scrollTop(window);
        let body            = document.body;

        if (scroll_position > 0) {
            window.helpers.addClass( body, 'shrink' )
        }
    },
    /**
     * Accordions
     */
    accordions: function(e) {
    
        e.preventDefault();

        let target = e.target;
        let parent = window.helpers.parent(target);
        let next   = window.helpers.next(target);

        window.helpers.toggleClass(parent, 'open');
        window.helpers.slideToggle(next);
        
    }

};





